<template>
  <Card class="grouped-chart">
    <div class="flex mx-3 pt-3">
      <select-control
        :value="groupBy"
        class="ml-auto"
        :disabled="loading"
        :options="[
                    {value: 'Day', label: $t('Daily')},
                    {value: 'Week', label: $t('Weekly')},
                    {value: 'Month', label: $t('Monthly')},
                    {value: 'Quarter', label: $t('Quarterly')},
                    {value: 'Year', label: $t('Yearly')},
                ]"
        @input="$emit('groupByChanged', arguments[0])"
      />

      <SegmentedButton
        class="ml-3"
        :value="type"
        :disabled="loading"
        :options="[
                    {value: 'bar', icon: 'BarChartIcon'},
                    {value: 'line', icon: 'LineChartIcon'},
                ]"
        @input="$emit('typeChanged', arguments[0])"
      />

      <ExportChart
        class="ml-3"
        :disabled="loading"
        @export="handleExport"
      />

    </div>
    <div v-if="loading" class="flex items-center justify-center" style="height:200px;">
      <Loader class="text-60" />
    </div>
    <Chart
      v-else
      ref="chart"
      class="chart"
      :class="[color]"
      :chart-data="data"
      :chart-starts-at="startsAt"
      :chart-ends-at="endsAt"
      :type="type"
      :tooltip-text="tooltipText"
      :high="high"
      :low="low"
      :format-y-labels="formatYLabels"
    />
  </Card>
</template>

<script>
  import Card from '@/_legacy/components/Card.vue';
  import Chart from '@/_legacy/views/Analytics/components/Chart.vue';
  import SegmentedButton from '@/_legacy/components/Controls/SegmentedButton.vue';
  import Loader from '@/_legacy/components/Icons/Loader.vue';
  import ExportChart from '@/_legacy/views/Analytics/components/ExportChart.vue';

  export default {
    components: {
      Card,
      Chart,
      SegmentedButton,
      Loader,
      ExportChart,
    },
    props: {
      loading: {
        type: Boolean,
        required: true,
      },
      data: {
        type: Object,
        required: true,
      },
      startsAt: {
        type: Number,
        required: true,
      },
      endsAt: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      groupBy: {
        type: String,
        required: true,
      },
      color: {
        type: String,
        required: true,
      },
      tooltipText: {
        type: String,
        required: true,
      },
      high: {
        type: Number,
      },
      low: {
        type: Number,
      },
      formatYLabels: {
        type: [Function, undefined],
        default: undefined,
      },
    },
    methods: {
      handleExport(format) {
        switch (format) {
          case 'png':
            this.$refs.chart.downloadPng();
            break;
          // no default
        }
      },
    },
  };
</script>
